import React from 'react';
import { observer } from 'mobx-react';
import DndList from './DndList';

@observer
export default class DndLists extends React.Component {
  renderDndList(dndList) {
    return <DndList className={'dndList'} key={`dndList${dndList.id}`} dndList={dndList} />;
  }

  render() {
    const dndLists = this.props.items;

    return <div className={'dndLists'}>{dndLists.map(this.renderDndList)}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/DnD/DndLists.js